<template>
  <div>
    <!-- 新動線の S3。電話番号・国籍を S1 から移してここで聞き、予約質問は旧動線と同じ一覧（ReservationQuestionFields）を使う -->
    <div class="mb-8 flex flex-col gap-[20px] font-Spectral">
      <!-- 代理予約では誰の連絡先かで当日の連絡先が変わる。旧動線は S1 の囲みが手掛かりになるので、同じ見出しをここにも出す -->
      <p v-if="form.step2.shouldShowSomeoneElseForm" class="text-sm font-semibold md:text-base">The lead participant's info</p>
      <GuestContactFields :get-error-message="getErrorMessage" />
    </div>
    <ReservationQuestionFields v-if="hasReservationQuestions" :get-error-message="getErrorMessage" />
  </div>
</template>

<script setup lang="ts">
import { useGlobalWabunkaReservationForm } from '@/wabunka-src/common/features/Reservation/composables/forms/useGlobalWabunkaReservationForm';
import GuestContactFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/GuestContactFields/GuestContactFields.vue';
import ReservationQuestionFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/ReservationQuestionFields/ReservationQuestionFields.vue';

interface Props {
  getErrorMessage: (s: string) => string;
}

defineProps<Props>();

const { form } = useGlobalWabunkaReservationForm();

const hasReservationQuestions = computed(() => form.value.step2.reservationQuestionAnswers.length > 0);
</script>
